import { Button, notification, Select, Input, Form, InputNumber, Card, List } from "antd"
import Title from "antd/es/typography/Title"
import { GetAllRoomTypes, UpdateRoom, GetRoomByID } from "../../../api/AdminService"
import { useNavigate, useParams } from "react-router-dom"
import { Option } from "antd/es/mentions"
import { useEffect, useState } from "react"
import { ArrowLeftOutlined } from "@ant-design/icons"
const AdminDetailRoom = () => {
    const navigate = useNavigate()
    const [form] = Form.useForm()
    const { id } = useParams();
    const [roomTypes, setRoomTypes] = useState([]);
    const [Room, setRoom] = useState([]);
    const [Edit, setEdit] = useState(false)
    const [loading, setLoading] = useState(false);
    const GetAllRole = () => {
        GetAllRoomTypes().then(res => {
            if (res.status === 200) {
                console.log(res.data)
                setRoomTypes(res.data)
            }
        })
    }

    const GetRoomID = (id) => {
        console.log(id)
        GetRoomByID(id).then(res => {
            if (res.status === 200) {
                console.log(res.data)
                setRoom(res.data)
                form.setFieldsValue({
                    name: res.data?.name,
                    capacity: res.data?.capacity,
                    status: res.data?.status,
                    roomType: res.data?.roomType?.id,
                    retreatGroupMembers: res.data?.retreatGroupMembers
                })
            }
        })
    }

    useEffect(() => {
        GetRoomID(id);
    }, [])

    useEffect(() => {
        GetAllRole();
    }, [])



    const onFinish = (values) => {
        setLoading(true);
        UpdateRoom(id, values.name, values.capacity, values.status).then(res => {
            if (res.status === 201) {
                console.log(res)
                notification.success({
                    message: "Update Room Successfully"
                })
                setLoading(false);
                setEdit(false)
            }
        }).catch(err => {
            console.log(err)
            notification.error({
                message: `${err.response.data.message}`
            })
            setLoading(false);
        })
    }


    return (
        // <div>AdminDetailRoom</div>
        <div style={{ minHeight: '96.5vh', Width: '100%' }}>
            <Button
                icon={<ArrowLeftOutlined />}
                onClick={() => navigate(-1)}
                style={{ marginBottom: 16 }}
            >
                Go Back
            </Button>

            <div style={{ maxWidth: 800, margin: 'auto', padding: '24' }}>

                <Title level={2} style={{ textAlign: 'center', marginBottom: '24' }}>
                    Room
                </Title>
                {Edit ? (
                    <Form
                        onFinish={onFinish}
                        form={form}
                    >
                        <Card title="Information" style={{ border: '1px solid #d9d9d9', borderRadius: '4px', marginBottom: 20 }}>
                            <Form.Item name={"name"} label="Room Name" rules={[{ required: true, message: 'Requiring Room Name' }]}>
                                <Input
                                    placeholder="Input Room Name"
                                />
                            </Form.Item>
                            <Form.Item name={"capacity"} label="Capacity" rules={[{ required: true, message: 'Requiring capacity' }]}>
                                <InputNumber min={1} style={{ width: '100%' }}
                                    placeholder="Input"
                                />
                            </Form.Item>
                            <Form.Item name={"roomType"} label="Room Type"

                                rules={[
                                    {
                                        required: true,
                                        message: 'Requiring Room Type',
                                    },
                                ]}
                            >
                                <Select disabled
                                    placeholder="Room Type"
                                >
                                    {roomTypes.map((item) => (
                                        <Option key={item.id} value={item.id}>
                                            {item.name}
                                        </Option>
                                    ))}

                                </Select>
                            </Form.Item>
                            <Form.Item name={"status"} label="Choose status"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Requiring Status',
                                    },
                                ]}

                            >
                                <Select
                                    placeholder="Choose status"
                                >
                                    <Option key={1} value={'Active'}>
                                        Active
                                    </Option>
                                    <Option key={2} value={"InActive"}>
                                        InActive
                                    </Option>

                                </Select>
                            </Form.Item>
                        </Card>

                        <Form.Item>
                            <Button block type="primary" htmlType="submit" loading={loading}>
                                {loading ? "Loading" : "Confirm Update"}
                            </Button>
                        </Form.Item>
                    </Form>
                ) : (
                    <>
                        <Form
                            form={form}
                            name="wrap"
                            labelAlign="left"
                            labelWrap
                            labelCol={{ flex: '150px' }}
                        >
                            <Card title="Information" style={{ border: '1px solid #d9d9d9', borderRadius: '4px', marginBottom: 20 }}>
                                <Form.Item name={"name"} label={<span style={{ fontSize: '16px' }}>Room Name</span>}
                                    style={{ borderBottom: '1px solid #d9d9d9', padding: '8px' }}>
                                    <Input disabled
                                        style={{
                                            border: 'none',
                                            color: 'rgba(0, 0, 0, 0.88)',
                                            width: '100%',
                                            backgroundColor: 'white',
                                            textAlign: 'left'
                                        }}
                                        placeholder="Input Room Name"
                                    />
                                </Form.Item>
                                <Form.Item name={"capacity"} label={<span style={{ fontSize: '16px' }}>Capacity</span>}
                                    style={{ borderBottom: '1px solid #d9d9d9', padding: '8px' }}>
                                    <InputNumber disabled
                                        style={{
                                            border: 'none',
                                            color: 'rgba(0, 0, 0, 0.88)',
                                            width: '100%',
                                            backgroundColor: 'white',
                                            textAlign: 'left'
                                        }}
                                        placeholder="Input"
                                    />
                                </Form.Item>
                                <Form.Item name={"roomType"} label={<span style={{ fontSize: '16px' }}>Room Type</span>}
                                    style={{ borderBottom: '1px solid #d9d9d9', padding: '8px' }}
                                >
                                    <Select disabled
                                        placeholder="Room Type"
                                        variant="borderless"
                                    >
                                        {roomTypes.map((item) => (
                                            <Option key={item.id} value={item.id}>
                                                {item.name}
                                            </Option>
                                        ))}

                                    </Select>
                                </Form.Item>
                                <Form.Item name={"status"} label={<span style={{ fontSize: '16px' }}>Status</span>}
                                    style={{ padding: '8px' }}
                                >
                                    <Input
                                        style={{
                                            border: 'none',
                                            color: 'rgba(0, 0, 0, 0.88)',
                                            width: '100%',
                                            backgroundColor: 'white',
                                            textAlign: 'left'
                                        }}
                                        placeholder="Choose status"
                                    />
                                </Form.Item>
                            </Card>
                            {(form.getFieldValue('retreatGroupMembers') && form.getFieldValue('retreatGroupMembers').length > 0) ? (
                                <Card title="Group Members" style={{ border: '1px solid #d9d9d9', borderRadius: '4px', marginBottom: 20 }}>
                                    <List
                                        dataSource={form.getFieldValue('retreatGroupMembers')}
                                        renderItem={retreatGroupMembers => (
                                            <List.Item key={retreatGroupMembers.id}>
                                                <List.Item.Meta
                                                    title={<div>{retreatGroupMembers.member.lastName} {retreatGroupMembers.member.firstName}</div>}
                                                    description={
                                                        <>
                                                            <p>phone: {retreatGroupMembers.member.phoneNumber}</p>
                                                            <p>gender: {retreatGroupMembers.member.gender}</p>
                                                        </>
                                                    }
                                                />
                                            </List.Item>
                                        )}
                                    />
                                </Card>
                            ) : (
                                <></>
                            )}

                        </Form>
                        <div style={{ marginTop: 5, marginBottom: 16 }}>
                            <Button block type="primary" onClick={() => setEdit(true)}>
                                Update Retreat
                            </Button>
                        </div>
                    </>
                )}

            </div>
        </div>
    )

}
export default AdminDetailRoom